import { render, staticRenderFns } from "./RentPayerTenant.vue?vue&type=template&id=4ebbd65d&scoped=true&"
import script from "./RentPayerTenant.vue?vue&type=script&lang=js&"
export * from "./RentPayerTenant.vue?vue&type=script&lang=js&"
import style0 from "./RentPayerTenant.vue?vue&type=style&index=0&id=4ebbd65d&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4ebbd65d",
  null
  
)

export default component.exports